import { Component, OnInit } from '@angular/core';

import { environment } from 'src/environments/environment';
import { ClientLoaderService } from '../core/util/client-loader.service';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'] 
})
export class InicioComponent implements OnInit {

  currentEnv: string;
  public reloadComponent:boolean=false;
  showTramitesCatalog = true;
  
  constructor(private clientLoader: ClientLoaderService) {
    this.currentEnv = environment.environment;
  }

  async ngOnInit(): Promise<void> {
    this.showTramitesCatalog = await this.clientLoader.hasTramitesCatalog();
  }

}
